/**
 * Dev-build flag — runtime wrapper around Vite's `import.meta.env.DEV`.
 *
 * This module reads `import.meta.env`, so it must NOT be imported by jest
 * tests (the dashboard runs jest in CJS, where `import.meta` is a syntax
 * error — same class as verifyFlag.ts). Components import `isDevBuild` from
 * here; tests jest.mock this module.
 */

/** True in `pnpm dev` (Vite sets `import.meta.env.DEV`), false in prod builds. */
export function isDevBuild(): boolean {
  return (import.meta as { env?: { DEV?: boolean } }).env?.DEV ?? false;
}
